import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    orange: '#FF4F21',
    blue: '#000648',
    blueLightOne: '#B7B8C5',
    blueLightTwo: '#112465',
    blueLightThree: '#315ADF',
    blueLightFour: '#2020DF',
    deepBlue700: '#112056',
    deepBlue: '#1F3575',
    white: '#FFFFFF',
    black: '#000000',
    greyLightOne: '#F5F5F5',
    greyLightTwo: '#5F5F5F',
    greyLightThree: '#878787',
    tertiaryGray100: '#DFDFDF',
    tertiaryGray400: '#838383',
    tertiaryGray900: '#212121',
  },
});